function ActivateElementFunction(): void {
    ById<HTMLElement>("activateElementDropdown").classList.add("show");
}

let elementToConsume: ElementType | null = null;

function UseElementFunction(elementType: ElementType, color: string): void {
    elementToConsume = elementType;

    const icon = ById<HTMLElement>("useElementIcon");
    icon.dataset.element = elementType;
    icon.style.color = color;

    ById<HTMLElement>("useElementPreview").style.borderColor = color;
    ById<HTMLElement>("useElementName").innerText = elementType;
    ById<HTMLElement>("useElementDropdown").classList.add("show");
}

function ApplyConditionFunction(event: MouseEvent): void {
    ById<HTMLElement>("applyConditionDropdown").classList.add("show");

    const participant = (event.currentTarget as ParticipantRow).participant;
    contextEnemyId = null;
    localStorage.setItem("nameSluggified", participant.nameSluggified);
    RenderContextTrackers(participant);
    RenderContextMode(participant);
    SetContextHeader(participant.name);
}

function SetContextHeader(name: string): void {
    const playerNameElements = document.getElementsByClassName("player-name");
    for (let i = 0; i < playerNameElements.length; i++) {
        (playerNameElements[i] as HTMLElement).innerText = name;
    }
}

function ApplyCondition(conditionAsString: ConditionType): void {
    const nameSluggified = localStorage.getItem("nameSluggified");
    if (nameSluggified && contextEnemyId !== null) {
        ApplyEnemyCondition(nameSluggified, contextEnemyId, conditionAsString);
        ById<HTMLElement>("applyConditionDropdown").classList.remove("show");
        return;
    }

    PostRoundWrite("condition:" + nameSluggified, "/Participant/AddCondition", {
        slugName: nameSluggified,
        conditionAsString: conditionAsString,
        roomKey: RoomKey()
    });

    ById<HTMLElement>("applyConditionDropdown").classList.toggle("show");
}

function ActivateElement(elementName: ElementType): void {
    PostRoundWrite("element:" + elementName, "/Element/ActivateElement", {
        elementName: elementName,
        roomKey: RoomKey()
    });

    ById<HTMLElement>("activateElementDropdown").classList.toggle("show");
}

function ConfirmUseElement(): void {
    if (elementToConsume === null) {
        return;
    }

    PostRoundWrite("element:" + elementToConsume, "/Element/UseElement", {
        elementName: elementToConsume,
        roomKey: RoomKey()
    });

    CancelUseElement();
}

function CancelUseElement(): void {
    elementToConsume = null;
    ById<HTMLElement>("useElementDropdown").classList.remove("show");
}

const POPUP_IDS = ["applyConditionDropdown", "activateElementDropdown", "useElementDropdown", "enemyMaxDropdown", "moodplayerControl"];

// The grey backdrop and every popup title call this, which is why a click anywhere beside an open popup
// closes it instead of reaching the row underneath.
function CloseAllPopups(): void {
    for (const id of POPUP_IDS) {
        TryById<HTMLElement>(id)?.classList.remove("show");
    }

    elementToConsume = null;
    enemyMaxGroup = null;
}
